<script setup lang="ts">
import { ref } from 'vue'
import mailingsHttpService from '@/services/http/mailingsHttpService'
import type { SmsTemplateModel, SmsTemplateTranslationModel } from '@/services/http/httpResponses'
import { Roles } from '@/constants'

definePage({
  meta: { allowedRoles: [Roles.Admin] },
})

const templates = ref<SmsTemplateModel[]>([])
const selectedTemplate = ref<SmsTemplateModel | null>(null)
const selectedTranslation = ref<SmsTemplateTranslationModel | null>(null)
const showPreviewDialog = ref(false)

const load = async () => {
  const res = await mailingsHttpService.getSmsTemplates()
  templates.value = res.templates
}

const openPreview = (template: SmsTemplateModel, translation: SmsTemplateTranslationModel) => {
  selectedTemplate.value = template
  selectedTranslation.value = translation
  showPreviewDialog.value = true
}

await load()
</script>

<template>
  <div class="flex flex-col gap-4 w-full">
    <h2 class="text-2xl font-semibold">SMS-шаблоны</h2>

    <DataTable :value="templates" dataKey="id">
      <Column field="code" header="Код" style="min-width: 14rem" />
      <Column header="Предпросмотр" style="min-width: 18rem">
        <template #body="slotProps">
          <div class="flex gap-2 flex-wrap">
            <Button
              v-for="tr in slotProps.data.translations"
              :key="tr.languageCode"
              :label="tr.languageCode.toUpperCase()"
              size="small"
              outlined
              @click="openPreview(slotProps.data, tr)"
            />
          </div>
        </template>
      </Column>
      <template #empty>
        <div class="flex flex-col gap-4 items-center">
          <span class="pi pi-mobile text-6xl" />
          <h3 class="font-medium">Шаблоны не найдены</h3>
        </div>
      </template>
    </DataTable>

    <Dialog
      v-model:visible="showPreviewDialog"
      :header="`${selectedTemplate?.code} · ${selectedTranslation?.languageCode?.toUpperCase()}`"
      :modal="true"
      class="w-[95vw] max-w-xl"
      :closable="true"
    >
      <div v-if="selectedTranslation" class="flex flex-col gap-2">
        <p class="text-sm text-gray-500">Текст сообщения</p>
        <p class="whitespace-pre-wrap">{{ selectedTranslation.value }}</p>
      </div>
    </Dialog>
  </div>
</template>

<style scoped></style>
